// Get tags here, tag count here
import type React from 'react';

import { Translate, TranslatePlural } from '@change-corgi/core/react/i18n';
import { ButtonLink } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconNotificationsNone } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { useAutoTaggedPetition } from './hooks/useAutoTaggedPetition';
import { AutoTaggedPetition as AutoTaggedPetitionReskin } from './index_new';

type Props = {
	onDismiss?: () => void;
};

export const AutoTaggedPetition: React.FC<Props> = ({ onDismiss }) => {
	const { data, actions } = useAutoTaggedPetition({ onDismiss });
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <AutoTaggedPetitionReskin onDismiss={onDismiss} />;
	}

	return (
		<Flex
			data-qa="auto-tagged-petition-message"
			data-testid="auto-tagged-petition-message"
			p={24}
			sx={{ height: '100%', gap: 16 }}
		>
			<Icon icon={iconNotificationsNone} size={24} color="primary-white" />
			<Flex sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
				<Heading as="h2" size="h4">
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.title"
						replacements={{ numTags: data.numTags }}
						count={data.numTags}
					/>
				</Heading>
				<Text mt={8}>
					<TranslatePlural
						value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.body"
						replacements={{ tags: data.tags.join(', ') }}
						count={data.numTags}
					/>
				</Text>
				<ButtonLink
					data-testid="auto-tagged-petition-button"
					variant="secondary"
					size="small"
					to={data.anchorLink}
					onClick={actions.handleEditTags}
					mt={16}
				>
					<Translate value="corgi.petition.starter_dashboard.notifications.auto_tagged_petition.primary_action_button" />
				</ButtonLink>
			</Flex>
		</Flex>
	);
};
